import React from 'react';
import {
  Container,
  Box,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';

const Layout = ({ children, showHeader = true }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#fafafa',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {showHeader && (
        <Box
          sx={{
            backgroundColor: 'white',
            borderBottom: '1px solid #e5e7eb',
            py: 2,
          }}
        >
          <Container maxWidth="lg">
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: '#1f2937',
                fontSize: { xs: '1.25rem', md: '1.5rem' },
              }}
            >
              SEGWAY CAPITAL
            </Typography>
          </Container>
        </Box>
      )}

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: { xs: 3, md: 6 },
          px: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <Container
          maxWidth="sm"
          sx={{
            width: '100%',
            maxWidth: { xs: '100%', sm: '480px' },
          }}
        >
          {children}
        </Container>
      </Box>

      <Box
        sx={{
          backgroundColor: 'white',
          borderTop: '1px solid #e5e7eb',
          py: 3,
          px: 2,
        }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              gap: 4,
              flexWrap: 'wrap',
            }}
          >
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                cursor: 'pointer',
                '&:hover': { color: 'primary.main' },
                fontSize: { xs: '0.875rem', md: '1rem' },
              }}
            >
              Terms of Service
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                cursor: 'pointer',
                '&:hover': { color: 'primary.main' },
                fontSize: { xs: '0.875rem', md: '1rem' },
              }}
            >
              Privacy Policy
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Layout; 